export const PROMPT_COMPONENT_METHOD = 'prompt-component-rendering';
